<template>
  <div :class="['contact-address', { 'disabled':!isEditable }]">
    <wrld-overlay-loader />
    <v-container>
      <v-row>
        <v-col cols="12">
          <h2>{{ direction === "origin" ? $t('orders.origin') : $t('orders.destination') }}</h2>
        </v-col>
        <v-col cols="12" class="py-0">
          <v-row>
            <v-col>
              <label for="company">{{$t('orders.company')}} *</label>
            </v-col>
            <v-col v-show="creatingNew">
              <v-btn x-small color="kazan" dark @click="addManagedOrganizationMenu = true" class="float-right">{{$t('buttons.add_new')}}</v-btn>
            </v-col>
          </v-row>
          <v-autocomplete
            v-if="isEditable"
            v-model="address_child.company"
            solo
            :items="companiesList"
            :rules="[v => !!v || $t('general.required_field')]"
            :disabled="!isEditable"
            :search-input.sync="companySearch"
          >
            <!-- <template v-slot:no-data>
              <v-col class="pl-2" cols="12">
                <p>{{$t('orders.company_not_found')}}</p>
                <p>
                  Press
                  <kbd>enter</kbd> to add "
                  <b>{{ companySearch }}</b>"
                </p>
              </v-col>
            </template> -->
          </v-autocomplete>
          <div v-else class="disabled-field">{{address_child.company}}</div>
        </v-col>
        <v-col cols="12" class="py-0">
          <v-row>
            <v-col>
              <label
                for="location"
              >{{ direction === "origin" ? $t('orders.location_pickup') : $t('orders.location_delivery') }} *</label>
            </v-col>
            <v-col v-show="address_child.company !== '' && creatingNew">
              <v-btn x-small color="kazan" dark @click="editLocationMenu = true" class="float-right">{{$t('buttons.add_new')}}</v-btn>
            </v-col>
          </v-row>
          <v-autocomplete
            v-if="isEditable"
            :disabled="address_child.company === '' || !isEditable"
            :placeholder="address_child.company === ''? $t('orders.company_must_be_filled'): ''"
            v-model="address_child.location"
            single-line
            solo
            :items="locationsList"
            :rules="[v => !!v || $t('general.required_field')]"
            :search-input.sync="locationSearch"
          >
            <!-- <template v-slot:no-data>
              <v-col class="pl-2" cols="12">
                <p>{{$t('orders.location_not_found')}}</p>
                <p>
                  Press
                  <kbd>enter</kbd> to add "
                  <b>{{ locationSearch }}</b>"
                </p>
              </v-col>
            </template> -->
          </v-autocomplete>
          <div v-else class="disabled-field">{{address_child.location}}</div>
        </v-col>
        <!-- <v-col cols="12">
          <label
            for="contact"
          >{{ direction === "origin" ? $t('orders.contact_origin') : $t('orders.contact_destination') }}</label>
          <v-autocomplete
            v-if="isEditable"
            :disabled="address_child.company === '' || !isEditable"
            :placeholder="address_child.company === ''? $t('orders.company_must_be_filled'): ''"
            v-model="address_child.contact_person"
            single-line
            solo
            :items="contactPersonList"
            :search-input.sync="personSearch"
          >
          </v-autocomplete>
        </v-col> -->
        <!-- <v-col cols="12">
          <label for="referenceNumber">{{$t('orders.ref_number')}}</label>
          <v-text-field
            v-if="isEditable"
            :disabled="!isEditable"
            v-model="address_child.reference_number"
            single-line
            solo
          ></v-text-field>
          <div v-else class="disabled-field">{{address_child.reference_number}}</div>
        </v-col> -->
        <v-col cols="12" class="py-0">
          <label
            for="open_hours"
          >{{ direction === "origin" ? $t('orders.open_hours_origin') : $t('orders.open_hours_destination') }} *</label>
          <v-row>
            <v-col cols="11" sm="5">
              <v-menu
                ref="menu_from"
                v-model="time_menu_from"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="address_child.open_from"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="address_child.open_from"
                    :label="$t('orders.open_from')"
                    prepend-icon="access_time"
                    readonly
                    v-on="on"
                    :disabled="!isEditable"
                    :rules="[v => !!v || $t('general.required_field')]"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="time_menu_from"
                  v-model="address_child.open_from"
                  format="24hr"
                  color="kazan"
                  header-color="#212121"
                  full-width
                  @click:minute="$refs.menu_from.save(address_child.open_from)"
                ></v-time-picker>
              </v-menu>
            </v-col>
            <v-col class="hidden-xs-only" align-self="center" sm="1" style="text-align: center">-</v-col>
            <v-col cols="11" sm="5">
              <v-menu
                ref="menu_to"
                v-model="time_menu_to"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="address_child.open_to"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="address_child.open_to"
                    :label="$t('orders.open_to')"
                    prepend-icon="access_time"
                    readonly
                    v-on="on"
                    :disabled="!isEditable"
                    :rules="[v => !!v || $t('general.required_field')]"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="time_menu_to"
                  v-model="address_child.open_to"
                  format="24hr"
                  color="kazan"
                  header-color="#212121"
                  full-width
                  @click:minute="$refs.menu_to.save(address_child.open_to)"
                ></v-time-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-col>
        <v-col class="mt-1 pb-0" cols="12">
          <label for="date_menu">{{ date_label }}</label>
          <v-checkbox
            color="kazan"
            v-model="address_child.fixedDate"
            :label="direction === 'origin' ? $t('orders.fixed_date_picup') : $t('orders.fixed_date_delivery')"
            hide-details
            :disabled="!isEditable"
          ></v-checkbox>
          <v-row>
            <v-col cols="11" sm="5">
              <v-menu
                v-model="date_menu_from"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="address_child.dates_from"
                    :label="address_child.fixedDate ? $t('orders.date') : $t('orders.from')"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                    :rules="[v => !!v || $t('general.required_field')]"
                    :disabled="!isEditable"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="address_child.dates_from"
                  color="kazan"
                  header-color="#212121"
                  :locale="$i18n.locale"
                  @input="date_menu_from = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col
              class="hidden-xs-only"
              v-show="!address_child.fixedDate"
              align-self="center"
              sm="1"
              style="text-align: center"
            >-</v-col>
            <v-col cols="11" sm="5" v-show="!address_child.fixedDate">
              <v-menu
                v-model="date_menu_to"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="address_child.dates_to"
                    :label="$t('orders.to')"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                    :disabled="!isEditable"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="address_child.dates_to"
                  color="kazan"
                  header-color="#212121"
                  :locale="$i18n.locale"
                  @input="date_menu_to = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <AddLocation
      v-if="address_child.company !== '' && creatingNew"
      :openMenu="editLocationMenu"
      @close="editLocationMenu = false"
      :orgID="address_child.company"
      @location-added="handleLocationAdded"
    />
    <AddOrganization
      v-if="creatingNew"
      :openMenu="addManagedOrganizationMenu"
      @close="addManagedOrganizationMenu = false"
      @organization-added="handleOrganizationAdded"
    />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
// import CompanyNewDialog from "@/components/companies/CompanyNewDialog.vue";
// import LocationNewDialog from "@/components/locations/LocationNewDialog.vue";
// import ContactNewDialog from "@/components/contacts/ContactNewDialog.vue";
import AddLocation from '@/components/organizations/locations/AddLocation'
import AddOrganization from '@/components/organizations/AddOrganization'
import { filterService, locationService, userService, organizationService } from "@/_services";

export default {
  name: "TransportFormAddress",
  components: {
    AddLocation,
    AddOrganization
    // CompanyNewDialog,
    // LocationNewDialog,
    // ContactNewDialog
  },
  props: {
    direction: String,
    value: Object,
    isEditable: { type: Boolean, default: true },
    creatingNew: { type: Boolean, default: true }
  },
  data() {
    return {
      companySearch: null,
      locationSearch: null,
      personSearch: null,
      time_menu_from: false,
      time_menu_to: false,
      date_menu_from: false,
      date_menu_to: false,
      address_child: JSON.parse(JSON.stringify(this.value)),
      companyDialog: false,
      locationDialog: false,
      contactDialog: false,
      orderStatus: [
        { value: "status-a", text: "Status A" },
        { value: "status-b", text: "Status B" },
        { value: "status-c", text: "Status C" }
      ],
      organizations: [],
      locations: [],
      contacts: [],
      orgQuery: "",
      editLocationMenu: false,
      addManagedOrganizationMenu: false
    };
  },
  computed: {
    ...mapGetters(["getResourceOverviewList"]),
    ...mapState(["route", "orders"]),
    locationsList() {
      let result = [];
      this.locations.forEach(loc => {
        let street = !!loc.address.street ? loc.address.street : ''
        let streetNo = !!loc.address.streetNo ? loc.address.streetNo : ''
        let postalCode = !!loc.address.postalCode ? loc.address.postalCode : ''
        let city = !!loc.address.city ? loc.address.city : ''
        let countryCode = !!loc.address.countryCode ? loc.address.countryCode : ''
        result.push({
          text: `${street} ${streetNo}, ${postalCode} ${city}, ${countryCode}`,
          value: loc.id
        });
      });
      return result;
    },
    companiesList() {
      let result = [];
      this.organizations.forEach(org => {
        result.push({ text: org.name + " (" + org.ref + ")", value: org.id });
      });
      return result;
    },
    contactPersonList() {
      return ["Person A", "Person B", "Person C"];
    },
    date_label() {
      return (
        (this.direction === "origin"
          ? this.$i18n.t("orders.date_origin")
          : this.$i18n.t("orders.date_destination")) + " *"
      );
    }
  },
  watch: {
    address_child: {
      deep: true,
      handler(value, old) {
        this.$emit("input", value);
        if (value.company !== old.company && value.company !== '') {
          this.fetchLocationsList(value);
        }
      }
    },
    "address_child.company": {
      deep: true,
      handler(value, old) {
        if (value !== null && value !== undefined) {
          this.fetchLocationsList(value);
          this.setCompanyObject(value)
        }
      }
    },
    "address_child.location": {
      deep: true,
      handler(value, old) {
        if (value !== null && value !== undefined) {
          this.setLocationObject(value)
        }
      }
    },
    dateToFix: {
      deep: true,
      handler(value, old) {
        if (value !== null) {
          this.$set(this.address_child, "dates_to", value);
        }
      }
    },
    value: {
      deep: true,
      handler(value, old) {
        this.address_child = this.value;
      }
    },
    companySearch(value) {
      if (value.length > 0) {
        this.getOrganzations(value);
      }
    }
  },
  methods: {
    ...mapActions({
      updateOrder: "updateOrder",
      fetchOrders: "fetchOrders",
      fetchLocations: "fetchLocations",
      setLoadingTime: "setLoadingTime"
    }),

    getOrganzations(query) {
      filterService
        .Organizations({ query: query, pageSize: 20 })
        .then(response => {
          this.organizations = this.organizations.concat(response.items)
        });
      if (query !== null && query !== '') {
        try {
          filterService
            .OrganizationsReference({ query: query })
            .then(response => {
              this.organizations = this.organizations.concat(response.items)
            });
        } catch (error) {
          // console.log(error)
        }
      }
    },
    fetchLocationsList(orgID) {
      locationService
        .getListLocations({ organizationID: orgID })
        .then(items => {
          this.locations = items;
          // this.setSecondResourceOverviewList({ items })
        });
    },
    // fetchContactsList(orgID) {
    //   userService
    //     .listContacts({ organizationID: orgID })
    //     .then(items => {
    //       this.contacts = items;
    //       // this.setSecondResourceOverviewList({ items })
    //     });
    // },
    setCompanyObject(orgID) {
      let company_obj = this.organizations.filter(obj => {
        return obj.id === orgID
      })
      this.address_child.company_obj = !!company_obj[0] ? company_obj[0] : {}
    },
    setLocationObject(locID){
      let location_obj = this.locations.filter(obj => {
        return obj.id === locID
      })
      this.address_child.location_obj = !!location_obj[0] ? location_obj[0] : {}
    },
    async handleOrganizationAdded(){
      await this.setLoadingTime(5000)
    },
    async handleLocationAdded(){
      await this.setLoadingTime(5000)
      this.fetchLocationsList(this.address_child.company)
    }
  },

  mounted() {
    this.getOrganzations(this.companySearch);
    if (this.address_child.company !== null && this.address_child.company !== '') {
      organizationService.getOrganization({ organizationID: this.address_child.company }).then((organization) => {
        this.organizations = this.organizations.concat(organization)
        this.fetchLocationsList(this.address_child.company)
        this.setCompanyObject(this.address_child.company)
        this.setLocationObject(this.address_child.location)
      })
    }
  }
};
</script>

<style scoped lang="scss">
.contact-address {
  padding: 15px;
}
.flex {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.from-directory-btn {
  float: right;
  margin: 0;
}
/* .v-btn--active {
        background-color: #ff5252 !important;
        color: white !important;
    } */
.v-picker {
  margin-top: 15px;
}
table.v-table tbody tr {
  cursor: pointer;
}
.contact-address {
  &.disabled {
    ::v-deep
      .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
      > .v-input__control
      > .v-input__slot {
      background-color: #ededed;

      .v-input__append-inner {
        display: none;
      }
    }
    ::v-deep .theme--light.v-input--is-disabled .v-label,
    .theme--light.v-input--is-disabled input,
    .theme--light.v-input--is-disabled textarea {
      color: rgba(0, 0, 0, 0.87);
    }
    ::v-deep input {
      color: rgba(0, 0, 0, 0.87);
    }
  }
}

.disabled-field {
  background-color: #ededed;
  -webkit-box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
    0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  padding: 16px 12px;
  border-radius: 2px;
  cursor: text;
  display: flex;
  margin-bottom: 28px;
  font-size: 16px;
  line-height: 16px;
  min-height: 48px;
}
</style>
